import FormCardSelect from 'components/molecules/formCardSelect/index.jsx';

export default props => {
  const {
    children,
    fieldValue,
    input: { value, onChange },
  } = props;

  const state = value === fieldValue ? { active: true } : {};

  function toggleState() {
    var newValue = null;

    if (value !== fieldValue) {
      newValue = fieldValue;
    }

    onChange(newValue);

    if (props.onChange) {
      props.onChange(newValue);
    }
  }

  return (
    <FormCardSelect {...state} onClick={toggleState}>
      {children}
    </FormCardSelect>
  );
};
